<template>
 
  <NavView></NavView>
  <SideBar></SideBar>
  {{this.my}}

  <div class="container-fluid">
      <!-- <h6 class=" font1 font-bold1 colr1 ">Create Customer</h6> -->
      <h6 class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/igrn/index"> Rental Return Note</router-link><span class="pfimg1"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Vehicle Return  </h6>



  
      <div class="card font1 ">
          <div class="card-body font1">

              <Form @submit="saveData()" class=" g-3"  :validation-schema="schema" v-slot="{ errors }" >
                  <div class="row ">
                      
                     

                     

                      <CCol md="3">
                          <CFormLabel for="inputName4">Received Date</CFormLabel>
                           <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                          

                           <Field name="discription" type="date" v-model="igrn.G_received_date"  class="form-control" :class="{ 'is-invalid': errors.discription}"
                           rules="required"  />
                          <span class="clr3 " >{{ errors.discription }}</span>
                          
                          
                      </CCol>
                      <CCol md="3">
                        
                        <CFormLabel for="inputName4">Reg. No</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        
                        
                        <select  v-model="igrn_cus"   @change="onChange(igrn_cus)" style="width:100%;"  class="form-control " >
                          <option></option>
                         
                        
                          <option type="button"  v-for="igrn1 in igrns" :key="igrn1.id" :value="igrn1.id" >{{igrn1.label}}</option>
                       
                         
                        </select>
                       
                      
                        
                    </CCol>
                      <CCol md="3">
                        <CFormLabel for="inputName4">Customer</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <Field id="igrn_customer" name="customer" v-model="igrn.cusname"  class="form-control"/>
                       
                        
                        
                    </CCol>
                      <CCol md="3">
                        <CFormLabel for="inputName4">GIN</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <Field name="gin" id="igrn_ginq" v-model="igrn.gin" class="form-control"/>
                       
                        
                        
                    </CCol>

                  </div><br>
                  <div class="row">
                    <CCol md="3">
                        <CFormLabel for="inputName4">Remarks</CFormLabel>
                         <!-- <CFormInput   v-model="customer.name"  type="text" id="inputName4"/> -->
                        

                         <textarea v-model="igrn.remarks" class="form-control"  rows="3"></textarea>    
                       
                        
                        
                    </CCol>

                  </div><br><br>

                  
                 <div id="my_hiden" class="d-none" >


                  <p class="clr2"><b>Rental Return Items</b> </p>

                  <table class="table table-bordered font1">
                    <tbody>
                      <tr >
                        <th >#</th>
                        <th >Product Code	 </th>
                        <th >Product Description </th>
                        <th >Registration No. </th>
                        <th >Qty </th>
                        <th >Return Date </th>
                        <th >Actual Start Date </th>
                        <th >Actual Return Date </th>
                        <th >Actual Return Time </th>
                        <th >Per Day Rate (Rs) </th>
                        <th >Fuel Return </th>
                        <th >Return Mileage </th>
                        <th >Returned Item Condition </th>
                  
                          
                      </tr>
                      <tr v-for="igrn_detail in igrn_details" :key="igrn_detail">
                        <td></td>
                        <td>{{igrn_detail.SD_idProduct}}</td>
                        <td>{{igrn_detail.SD_idProduct}}</td>
                        <td>{{igrn_detail.serial_no}}</td>
                        <td></td>
                        <td>{{igrn_detail.to_date}}<br>{{igrn_detail.to_time}}</td>
                        <td>{{igrn_detail.from_date}}<br>{{igrn_detail.from_time}}</td>
                        <td><input class="form-control" type="date"> </td>
                        <td><input type="time"></td>
                        <td>{{igrn_detail.charge_amount}}</td>
                        <td>
                          <select>
                            <option>Select Option</option>
                            <option>Full</option>
                            <option>Not Full</option>
                          </select>
                        </td>
                        <td><input class="form-control" type="text"></td>
                        <td>
                          <select>
                            <option>Select Option</option>
                            <option>Item Working Properly</option>
                            <option>Damaged</option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  
                
                  
                </div>
                
            
             
                 
                  

                  

                  

                  
                  
                  <CCol class="right1 mt-4">
                  
                  
                      <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-5">
                      
                          <CButton  color="success" class="btn1" type="submit"> Create</CButton>
                          <router-link class="line1 btn btn-danger " to="/igrn/index">Cancel</router-link>
                          
                      </div>
                  </CCol>
              </Form>
           



          </div>
      </div>


     
       
         


  </div>
  <!-- <button v-on:click="loadData1()" type="" class="btn btn-danger" >press</button> -->
  <!-- <form @submit.prevent="del()" class="" >
   <input type="text" v-model="user.id"  class="form-control" >
   <button  type="" class="btn btn-success" >delete</button>
   </form> -->

</template>

<script>
  import {  CCol, CFormLabel,   CButton, } from '@coreui/vue';
  import { defineRule,Form, Field  } from 'vee-validate';
  //import httpClient from '@/axios';
  import NavView from '../../components/NavView.vue'
  import SideBar from '../../components/SideBar.vue'
  import authService from '@/auth.service';
  import axios from 'axios';
  import "vue-select/dist/vue-select.css";
  import $ from "jquery";


  
 
  defineRule('minMax', (value, [min, max]) => {
// The field is empty so it should pass
if (!value || !value.length) {
  return true;
}
const numericValue = Number(value.length);
if (numericValue < min) {
  return 'Please enter a valid phone number.';
}
if (numericValue > max) {
  return 'Please enter a valid phone number.';
}
return true;
});

  defineRule('required', value => {
   if (!value || !value.length) {
  return 'This field is required';
  }
  return true;
  });

  defineRule('email', value => {
// Field is empty, should pass
if (!value || !value.length) {
  return true;
}
// Check if email
if  (!/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/.test(value)) {
  
  return 'Please enter valid email address';
  
}
return true;
});



  

  export default {
     


    


    
  
    created(){
  this.loadVehicles();

    },

     function(){
 

      
},


      data() {
     
       

      
  
          return {

            access_token:authService.isLoggedIn(),

              isHidden: false,
              count: 0,
              values:{},

              isHidden1: false,
              count1: 0,
              values1:{},
               
              igrn_cus:'',
           
            igrn:{
             serial_no:'1',
             gin:'',
             cusname:'',
            },


            igrn_details:{

            },
            
            igrns:{
              
            },
            

            
             
          };
      },

      // validation:{
      //     customer: {
      //         name:{
      //             required,
      //             minLength: minLength(2),

      //         }



      //     },


      // },


      components: {
          CCol,Field, CFormLabel,   CButton,Form,NavView,SideBar
      },

      methods: {
        async loadVehicles() {
   
   console.log(this.access_token);
  
   try {
     const { data} = await  axios.get('/web/api/istockissuedetails/rentedvehicleslist' ,{
     headers:{
       'Authorization':'Bearer '+this.access_token,
       'Content-type': 'application/json',
      
     }
    });
    console.log(data);
    this.igrns = data.item_list;
   } catch (error) {
     console.log(error);
   }

 },


 async onChange(value) {
  $('#my_hiden').removeClass('d-none');
   console.log(this.access_token);
   console.log(value);
  
   try {
     const { data} = await  axios.get('/web/api/istockissuedetails/searchcustomer?id='+value ,{
     headers:{
       'Authorization':'Bearer '+this.access_token,
       'Content-type': 'application/json',
      
     }
    });
    console.log(data);
   this.igrn = data;
   } catch (error) {
     console.log(error);
   }


   try {
     const { data} = await  axios.get('/web/api/istockissuedetails/loadrentalitemlist?gin='+value  ,{
     headers:{
       'Authorization':'Bearer '+this.access_token,
       'Content-type': 'application/json',
      
     }
    });
    console.log(data);
   this.igrn_details = data.item_list;
   } catch (error) {
     console.log(error);
   }

 },





     

          async saveData() {
    // console.log("here we are",this.errorlist); check karaganimata awashya we
    console.log('amila');
    console.log(this.igrn_cus)
    console.log(this.igrn);
    console.log(this.igrn_details);
    
   
    try {
      const { data} = await  axios.post('/web/api/igrn/create' ,{igrn:this.igrn,detail:this.igrn_details},{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
    } catch (error) {
      console.log(error);
    }
  //   await httpClient.post('web/index.php/mcustomer/send',this.customer).then(
  //     response => {
  //       console.log(response);
  //      this.item = response.data.success;
         //window.location.reload();
        
    //  }
     
     //)
      
 

  },

 
  
      







      
  }

  };


</script>

<style scoped>
 .font1{
  font-size: 13px !important;

}
.font-bold1{
  font-weight: bold;
}
 
  .clr1 {
      background-color: #D4E1E8;
      padding: 2px;
      padding-left: 20px;
  }

  .clr2 {
      background-color: #AED8F2;
      padding: 2px;
      border-radius: 3px
  }

  .right1 {
      text-align: right;
  }

  .btn1 {
      padding-left: 22px;
      padding-right: 22px;
  }

  .clr3 {
      color: red;
  }

  .left1{
      text-align: left;
  }

  .width1{
      width: 25%;
  }
  .width2{
      width: 20%;
  }

  .hiden1 {
      display: none;
  }
  .button2{
      margin-left: 5px;
  }
  .manage-boder{
  border-bottom: 2px solid #E9E9E3;
  border-top: 2px solid #E9E9E3;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
  
  }
  .font1{
    font-size: 13px !important;
 
  }
  .font-bold1{
    font-weight: bold !important;
  }
  .colr1{
      color:#A5A5A3;
      
  }
  .decoration{
  text-decoration: none;
  color:#A5A5A3  ;
}
.body1{
  border-top: 1px solid black;
}
.group 			  { 
position:relative; 
margin-bottom:10px; 


}
.input3 				{
font-size:14px;
padding:10px 10px 3px 5px;
display:block;
width:90%;
border:none;
border-bottom:2px solid #999;
}
.input3:focus 		{ outline:none; }

/* LABEL ======================================= */
.label1 				 {
color:#999; 
font-size:13px;
font-weight:normal;
position:absolute;
pointer-events:none;
left:5px;
top:10px;
transition:0.2s ease all; 
-moz-transition:0.2s ease all; 
-webkit-transition:0.2s ease all;
}

/* active state */
.input3:focus ~ .label1, .input3:valid ~ .label1 		{
top:-10px;
font-size:13px;
color:#999;
}
</style>